import { useCallback } from 'react';

import { ComposerWrapper } from 'components/composer/composer-wrapper';

const IndexComposer = ({ workspace, router, store, types = [] }) => {
	const onSend = useCallback(async () => {
		await router.push('/auth?view=register&next=/home');
	}, [router]);

	return (
		<div className='mx-auto mt-8 w-full max-w-md text-left'>
			<ComposerWrapper workspace={workspace} router={router} store={store} types={types} onSend={onSend} />
		</div>
	);
};

export { IndexComposer };
